import type { Board } from 'chessboard/model/board/types';
import type { Game } from 'chessboard/model/game/types';
import type { StateMachine } from 'chessboard/core/state/config/types';

/**
 * A set of functions to handle updating the params in response to effects
 * from the "pieces" middleware.
 */
export function createUpdateParams(params: StateMachine.Params): StateMachine.UpdateParams {
  return {
    cancelMarkingStartSquare,
    cancelPromotion,
    deselectPiece,
    dragPiece,
    dropPiece,
    resetElevatedState,
    selectPiece,
    setMarkingStartSquare,
    showPromotionArea,
  };

  /**
   * Unset the square that the analysis starts on.
   */
  function cancelMarkingStartSquare(): void {
    params.markingStartSquare = undefined;
  }

  /**
   * Cancel the promotion move.
   */
  function cancelPromotion(): void {
    params.promotionMove = undefined;
  }

  /**
   * Deselect a piece.
   */
  function deselectPiece(): void {
    params.selectedPiece = undefined;
  }

  /**
   * Set a piece's coords and dragging square.
   */
  function dragPiece(coords: Board.Coords, square: Board.SanSquare): void {
    params.draggingPiece = square;
    params.draggingCoords = coords;
  }

  /**
   * Drop a piece.
   */
  function dropPiece(): void {
    params.draggingPiece = undefined;
    params.draggingCoords = undefined;
  }

  /**
   * Reset the state to 'idle'
   */
  function resetElevatedState(): void {
    params.draggingPiece = undefined;
    params.draggingCoords = undefined;
    params.promotionMove = undefined;
    params.selectedPiece = undefined;
  }

  /**
   * Select a piece
   */
  function selectPiece(square: Board.SanSquare): void {
    params.selectedPiece = square;
  }

  /**
   * Set the parameter for the square that the analysis starts on.
   */
  function setMarkingStartSquare(square: Board.SanSquare): void {
    params.markingStartSquare = square;
  }

  /**
   * Show the promotion area and set the temporary promotionMove
   */
  function showPromotionArea(move: Game.Move.Model): void {
    params.promotionMove = { ...move };
  }
}
